// Envio de item do catalogo numa conversa do WhatsApp — logica compartilhada
// entre o CatalogoPicker (Inbox) e a pagina /catalogo. Mesmo padrao do anexo
// manual do ChatWindow: pre-cria a mensagem pending e a edge function confirma.

import { supabase } from "@/integrations/supabase/client";
import type { CatalogoItem } from "@/hooks/useCatalogoMidia";

export interface DestinoConversa {
  conversationId: string;
  telefoneCliente: string;
  connectionId: string;
}

export async function enviarItemCatalogoParaConversa(item: CatalogoItem, destino: DestinoConversa) {
  const { conversationId, telefoneCliente, connectionId } = destino;
  if (!conversationId || !telefoneCliente || !connectionId) {
    throw new Error("Conversa sem dados completos");
  }
  const caption = `*${item.titulo}*${item.descricao ? `\n\n${item.descricao}` : ""}`;

  const { data: { user } } = await supabase.auth.getUser();
  const { data: msgRow, error: insErr } = await supabase
    .from("whatsapp_messages")
    .insert({
      conversation_id: conversationId,
      direction: "outbound",
      type: "image",
      body: caption,
      media_url: item.imagem_url,
      mime_type: "image/jpeg",
      status: "pending",
      message_source: "humano",
      sent_by_user_id: user?.id,
    })
    .select("id")
    .single();
  if (insErr) throw insErr;

  const { data, error } = await supabase.functions.invoke("whatsapp-evolution-send", {
    body: {
      to: telefoneCliente,
      conversation_id: conversationId,
      connection_id: connectionId,
      message_id: msgRow.id,
      media_url: item.imagem_url,
      media_type: "image",
      mime_type: "image/jpeg",
      caption,
    },
  });
  if (error) throw new Error(error.message);
  if (data && (data as { ok?: boolean }).ok === false) {
    throw new Error((data as { error?: string }).error || "Falha no envio");
  }
  if (data && (data as { success?: boolean }).success === false) {
    const d = data as { erro_detalhe?: string; error?: string };
    throw new Error(d.erro_detalhe || d.error || "Falha no envio");
  }

  await supabase
    .from("whatsapp_conversations")
    .update({
      last_message_preview: `📷 ${item.titulo}`.slice(0, 120),
      last_message_at: new Date().toISOString(),
      last_outbound_at: new Date().toISOString(),
    })
    .eq("id", conversationId);
}
